/**
 * Sign-in route — /sign-in
 *
 * Public (unauthenticated) route so `signInUrl="/sign-in"` (set on the
 * ClerkProvider in main.tsx) resolves to a real in-app page. The auth gate in
 * __root.tsx lets /sign-in and /sign-up through to their own components.
 */
import { createFileRoute } from '@tanstack/react-router';
import { SignInScreen } from '@/features/auth/SignInScreen';

export const Route = createFileRoute('/sign-in')({
  component: SignInScreen,
});
